<app-protected-content [requiredRoles]="requiredRoles">
  <div class="container" *transloco="let t; prefix: 'dsaManagement.infrastructure'">
    <div class="panel">
      <htx-tabs [tabs]="tabs" (tabChanged)="onTabChange($event)">
        @if (activeTabId() === 'discovery-service') {
          <div class="tab-content">
            <div class="tab-header">
              <div class="tab-header-info">
                <h2 class="tab-title">{{ t('tabs.discoveryService') }}</h2>
                <p class="tab-description">{{ t('descriptions.discoveryService') }}</p>
              </div>
              <div class="tab-header-actions">
                @if (getHealthStatus('DISCOVERY_SERVICE'); as status) {
                  <htx-badge
                    [text]="status === 'UP' ? 'Online' : 'Offline'"
                    [variant]="status === 'UP' ? 'success' : 'danger'"
                  ></htx-badge>
                }
                <htx-button variant="primary" size="small" icon="add" (buttonClick)="addDiscovery()">
                  {{ t('actions.addDiscovery') }}
                </htx-button>
              </div>
            </div>

            @if (discoveryLoading()) {
              <div class="loading">
                <htx-loading-dots size="medium"></htx-loading-dots>
              </div>
            } @else if (discoveryData().length === 0) {
              <p class="empty-state">{{ t('empty') }}</p>
            } @else {
              <htx-table
                [data]="discoveryData()"
                [columns]="discoveryColumns"
                [rowIdField]="'bpnl'"
              ></htx-table>
            }
          </div>
        }

        @if (activeTabId() === 'dim-wallet') {
          <div class="tab-content">
            <div class="tab-header">
              <div class="tab-header-info">
                <h2 class="tab-title">{{ t('tabs.dimWallet') }}</h2>
                <p class="tab-description">{{ t('descriptions.dimWallet') }}</p>
              </div>
              @if (getHealthStatus('DIM_WALLET_STUB'); as status) {
                <htx-badge
                  [text]="status === 'UP' ? 'Online' : 'Offline'"
                  [variant]="status === 'UP' ? 'success' : 'danger'"
                ></htx-badge>
              }
            </div>

            @if (walletLoading()) {
              <div class="loading">
                <htx-loading-dots size="medium"></htx-loading-dots>
              </div>
            } @else if (walletData().length === 0) {
              <p class="empty-state">{{ t('empty') }}</p>
            } @else {
              <htx-table
                [data]="walletData()"
                [columns]="walletColumns"
                [rowIdField]="'bpn'"
              ></htx-table>
            }
          </div>
        }

        @if (activeTabId() === 'bdrs') {
          <div class="tab-content">
            <div class="tab-header">
              <div class="tab-header-info">
                <h2 class="tab-title">{{ t('tabs.bdrs') }}</h2>
                <p class="tab-description">{{ t('descriptions.bdrs') }}</p>
              </div>
              <div class="tab-header-actions">
                @if (getHealthStatus('BDRS'); as status) {
                  <htx-badge
                    [text]="status === 'UP' ? 'Online' : 'Offline'"
                    [variant]="status === 'UP' ? 'success' : 'danger'"
                  ></htx-badge>
                }
                <htx-button variant="primary" size="small" icon="add" (buttonClick)="addBdrs()">
                  {{ t('actions.addBdrs') }}
                </htx-button>
              </div>
            </div>

            @if (bdrsLoading()) {
              <div class="loading">
                <htx-loading-dots size="medium"></htx-loading-dots>
              </div>
            } @else if (bdrsData().length === 0) {
              <p class="empty-state">{{ t('empty') }}</p>
            } @else {
              <htx-table
                [data]="bdrsData()"
                [columns]="bdrsColumns"
                [rowIdField]="'bpn'"
              ></htx-table>
            }
          </div>
        }
      </htx-tabs>
    </div>
  </div>

  <ng-template #discoveryActionTemplate let-row>
    @let org = getDiscovery(row);
    <div class="action-buttons">
      <htx-button
        variant="tertiary"
        icon="edit"
        [iconOnly]="true"
        [tooltip]="'dsaManagement.infrastructure.actions.edit' | transloco"
        (buttonClick)="editDiscovery(org)"
      ></htx-button>
      <htx-button
        variant="tertiary"
        icon="delete"
        [iconOnly]="true"
        [tooltip]="'dsaManagement.infrastructure.actions.delete' | transloco"
        (buttonClick)="deleteDiscovery(org)"
      ></htx-button>
    </div>
  </ng-template>

  <ng-template #bdrsActionTemplate let-row>
    @let entry = getBdrs(row);
    <div class="action-buttons">
      <htx-button
        variant="tertiary"
        icon="edit"
        [iconOnly]="true"
        [tooltip]="'dsaManagement.infrastructure.actions.edit' | transloco"
        (buttonClick)="editBdrs(entry)"
      ></htx-button>
      <htx-button
        variant="tertiary"
        icon="delete"
        [iconOnly]="true"
        [tooltip]="'dsaManagement.infrastructure.actions.delete' | transloco"
        (buttonClick)="deleteBdrs(entry)"
      ></htx-button>
    </div>
  </ng-template>
</app-protected-content>
